import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AdminOverviewService {
  private http = inject(HttpClient);


  url = (): string => `${environment.api}/v1/admin/settings`;

  fetch(): Promise<Record<string, unknown>> {
    return this.http.get<Record<string, unknown>>(this.url()).toPromise();
  }

  saveSetting(name: string, value: unknown): Observable<void> {
    return this.http.put<void>(this.url(), {name, value});
  }
}
